type RuntimeConfigMap = Record<string, string | undefined>

declare global {
  interface Window {
    __CONFIG__?: RuntimeConfigMap
  }
}

export const getRuntimeConfig = (key: string, fallback?: string): string => {
  const runtimeConfig = window.__CONFIG__ ?? {}
  const value = runtimeConfig[key]
  return value && value.length > 0 ? value : fallback ?? ''
}
